import { Box, Dialog, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import DollarSign from "../../../icons/DollarSign.svg";
import { PaymentRequestBalanceDto } from "@inosio/payments-sdk";


interface PRCancelledModalProp {
    open: boolean,
    PaymentRequestDetails: PaymentRequestBalanceDto | null;
    text: string;
}

const PRCancelledModal = (props: PRCancelledModalProp) => {
    const { open, PaymentRequestDetails, text } = props
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
    };

    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
                        <Grid item display="flex" flexDirection="column">
                            {isOnMobileScreen ?
                                <Grid item display='flex' justifyContent='center'>
                                    <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                                        <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                        <Typography
                                            sx={{
                                                fontFamily: "Work Sans",
                                                fontStyle: 'normal',
                                                fontWeight: 700,
                                                fontSize: '18px',
                                                lineHeight: '23px',
                                                color: '#14142B',
                                                textAlign: 'left',
                                                padding: '15px'
                                            }}>
                                            {PaymentRequestDetails?.CompanyName}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                : <></>}
                            <Grid item display='flex' justifyContent='center'>
                                <Typography sx={{
                                    fontFamily: "Work Sans",
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                    lineHeight: '23px',
                                    color: '#14142B',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '30px'
                                }}>
                                    Payment Request
                                </Typography>
                            </Grid>
                            <Grid item display="flex" justifyContent='center' pt={4}>
                                <img src={DollarSign} alt='dollar' />
                            </Grid>
                            <Grid item display="flex" flexDirection="column" alignItems='center' pt={2} >
                                <Grid item pl={10} pr={8} justifyContent='center'>
                                    <Typography
                                        sx={{
                                            fontFamily: "Work Sans",
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            fontSize: '16px',
                                            lineHeight: '23px',
                                            color: '#000000',
                                            textAlign: 'center',
                                            marginTop: '10px'
                                        }}>
                                        The {text} has been cancelled. Please contact the Property Manager if you still need to make a payment.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent >
        </Dialog >
    );
}

export default PRCancelledModal;
